import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { money } from "@/components/reports/reportUtils";

export function ReporteRutas({ data }) {
  const items = data?.items || [];
  return (
    <Table data-testid="reporte-rutas-table">
      <TableHeader>
        <TableRow>
          <TableHead>Ruta</TableHead><TableHead className="text-right">Viajes</TableHead>
          <TableHead className="text-right">Facturación</TableHead><TableHead className="text-right">Costo Prom.</TableHead>
          <TableHead className="text-right">Ganancia</TableHead><TableHead className="text-right">Margen %</TableHead>
          <TableHead className="text-right">Margen Objetivo</TableHead><TableHead className="text-right">Desvío (pp)</TableHead>
          <TableHead className="text-right">Fuera de Tarifa</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {items.map((r) => (
          <TableRow key={r.ruta} data-testid={`reporte-rutas-row-${r.ruta}`}>
            <TableCell>{r.ruta}</TableCell>
            <TableCell className="text-right">{r.cantidad_viajes}</TableCell>
            <TableCell className="text-right">{money(r.facturacion_usd)}</TableCell>
            <TableCell className="text-right">{money(r.costo_promedio_usd)}</TableCell>
            <TableCell className="text-right">{money(r.ganancia_usd)}</TableCell>
            <TableCell className="text-right">{r.margen_pct}%</TableCell>
            <TableCell className="text-right">{r.margen_objetivo_tarifario_pct ?? "—"}{r.margen_objetivo_tarifario_pct != null ? "%" : ""}</TableCell>
            <TableCell className="text-right">
              {r.desvio_vs_tarifario_pp == null ? "—" : (
                <Badge variant={r.desvio_vs_tarifario_pp < 0 ? "destructive" : "secondary"}>{r.desvio_vs_tarifario_pp} pp</Badge>
              )}
            </TableCell>
            <TableCell className="text-right">{r.viajes_fuera_de_tarifa}</TableCell>
          </TableRow>
        ))}
        {items.length === 0 && (
          <TableRow><TableCell colSpan={9} className="text-center text-sm text-muted-foreground py-8">Sin resultados para los filtros aplicados.</TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  );
}
